import { FeatureGroup } from "react-leaflet";

/*
  無を表示するレイヤー
*/
export const EmptyLayer: React.FC = () => {
  /* 空のFeatureGroupは、LayersControlに認識させるために必要 */
  return <FeatureGroup />;
};
